<div class="question-panel">
  <div class="custom-answer__group custom-answer__group--value form-group mb-0" id="ca-example-7">
    @for (item of questions; track item; let index = $index) {
      <div class="custom-answer">
        <div class="custom-answer__title">
          <label>{{item.list_name}}</label>
        </div>
        <div class="custom-answer__amount">
          <input currencyMask type="text" [placeholder]="maskOptions?.prefix + '0'" class="form-control"
            [(ngModel)]="item.list_value" [options]="maskOptions" (ngModelChange)="saveValue()">
          </div>
        </div>
      }
    </div>
    @if (showTotal) {
      <div class="question-panel__total">
        <div class="question-panel__total-name">
          <p>Total</p>
        </div>
        <div class="question-panel__total-amount">
          <p><span>{{ globalQuestionService?.accounting?.formatMoney(totalAmount)}}</span></p>
        </div>
      </div>
    }
  </div>
